export default __webpack_public_path__ + "static/media/logo-ethos-pdf.8b8114b4.jpg";